import '../../../../shared/public/js/vendor/jquery.typeahead.min.js';
import orderBy from 'lodash/orderBy';
import find from 'lodash/find';
import { getLang, normalizeString, romanLangs } from './_utils';
import { validateField } from './form.js';

const selector = {
	container: 'TypeAhead-container',
	field: 'TypeAhead-field',
	query: 'TypeAhead-query',
	result: 'TypeAhead-results',
	list: 'TypeAhead-list',
	item: 'TypeAhead-item',
};

/**
 * Make sure a typeahead field is valid
 *
 * @param {jQuery}	node - The jQuery object for the select element
 * @param {Object}	dataset - The total object of data for the field
 * @param {jQuery}	$component - The jQuery object for the container component (.TypeAhead)
 *
 */
function validate(node, dataset, $component) {
	const value = node.val();
	const generalText = $component.data('generalText');
	const objValue = find(dataset, obj => obj.shortName === value);
	if ((generalText.length > 0 && value === generalText) || objValue) {
		node.data('valid', true);
		node.data('value', objValue && objValue.hotelCode ? objValue.hotelCode : 'GENERAL');
	} else {
		node.data('valid', false);
	}
}

export default function typeAhead() {
	const lang = getLang().slice(0, 2);
	const typeAheadContainer = $(`.${selector.container}`);

	$('.TypeAhead').each((i, component) => {
		const $component = $(component);
		const $inputField = $component.find('.TextInput-field');
		const entryPoint = $component.data('entryPoint');
		const defaultKey = $component.data('defaultKey');

		fetch(entryPoint, { credentials: 'same-origin' })
			.then(res => res.json())
			.then(data => orderBy(data, ['shortName'], ['asc']))
			.then(dataset => {
				$inputField.typeahead({
					order: 'asc',
					minLength: 1,
					maxItem: 5,
					// TODO: Write tests for this
					filter: function (item, displayKey) {
						const key = normalizeString(displayKey);
						const query = normalizeString(this.query);
						const sanitizedQuery = query
							.trim()
							.replace(/[,-]/g, '')
							.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');

						// If the language is roman, look for words
						if (romanLangs.includes(lang)) {
							if (new RegExp(`(\\b${sanitizedQuery})`, 'g').test(key)) {
								return true;
							}
							return false;
						}

						// If not, look for characters after word separators
						const matchIndex = key.indexOf(query);
						if (matchIndex === 0 || /[\s-\/(]/.test(key[matchIndex - 1])) {
							return true;
						}

						return false;
					},
					cancelButton: false,
					display: ['shortName'],
					source: {
						hotels: {
							data: dataset,
						},
					},
					template: function (query, item) {
						return `<span class="TypeAhead-itemText ${
							item.matchedKey === 'general' ? 'ty-c3' : ''
						}">{{shortName}}</span>`;
					},
					callback: {
						onResult: function (node, query, result, resultCount, resultCountPerGroup) {
							var shortName = $component.data('generalText');
							if (shortName.length > 0) {
								typeAheadContainer.addClass('TypeAhead-generalInquiry');
								result.push({
									shortName: shortName,
									group: 'hotels',
									general: $component.data('generalText'),
									matchedKey: 'general',
								});
							}
						},
						onShowLayout: function (node, query) {
							node.attr('aria-expanded', 'true');
							$component.find(`.${selector.result}`).fadeIn(500);
						},
						onHideLayout: function (node, query) {
							$component.find(`.${selector.result}`).fadeOut(500);
							node.attr('aria-expanded', 'false');
							this.result = [];
						},
						onLayoutBuiltBefore: function (node, query, result, resultHtmlList) {
							if (!resultHtmlList) {
								return;
							}
							resultHtmlList
								.attr('role', 'listbox')
								.attr('id', $component.data('resultsId'));
							resultHtmlList
								.find(`.${selector.item}`)
								.attr('role', 'option')
								.attr('aria-selected', 'false')
								.each((index, item) =>
									$(item).attr('id', `${$component.data('resultsId')}-${index}`)
								);
							node.attr('aria-activedescendant', '');
							return resultHtmlList;
						},
						onNavigateAfter: function (node, lis, a, item, query, event) {
							const active = lis.filter('.active');
							lis.attr('aria-activedescendant', '');
							lis.attr('aria-selected', 'false');
							active.attr('aria-selected', 'true');
							node.attr('aria-activedescendant', active.attr('id'));
						},
						onClickAfter: function (node, a, item, event) {
							validate(node, dataset, $component);
							validateField(node);
							node.parents('.ValidatedForm-form').trigger('validate.form');
						},
						onReady: function (node) {
							if (typeof defaultKey !== 'string' && defaultKey !== '') {
								return;
							}
							const matchedKey = find(dataset, obj => obj.hotelCode === defaultKey);
							if (matchedKey !== undefined && matchedKey !== '') {
								node.val(matchedKey.shortName);
								node.data('valid', true);
								node.data('value', defaultKey);
								validateField(node);
							}

							node.on('validate', e => {
								e.stopPropagation();
								validate(node, dataset, $component);
							});
						},
					},
					selector,
				});
			});
	});
}
